/* eslint-disable */
import clsx from "clsx";
import styles from "./style.module.scss";
import { secondary } from "@/hooks/useFonts";

type Props = {
  title?: string;
  desc?: string | React.ReactNode;
  size: "sm" | "md" | "lg" | "xlg";
  onClick?: () => void;
  style?: any;
  customClass?: string;
};
export default function TableInfo({
  title,
  desc,
  size = "sm",
  onClick,
  style,
  customClass,
}: Props) {
  return (
    <div className={clsx(styles.tableinfo, styles[size])}>
      {title && <div className={clsx(styles.title, secondary)}>{title}</div>}
      {desc && (
        <div
          className={`${clsx(styles.desc)} ${customClass}`}
          style={style}
          onClick={() => onClick?.()}
        >
          {desc}
        </div>
      )}
    </div>
  );
}
